// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130548/js/" + chunkId + "." + {"44":"0e5724c2","225":"1e4fe57a","481":"c2d34b2e","486":"4fbb60e2","770":"36702bde"}[chunkId] + ".0.6466349965876663.chunk.js";
};